import { FormField, FormHelp, Label } from '@zillow/constellation-10';
import { HomeType } from '@zg-rentals/ts-capps-client';
import { Controller } from 'react-hook-form';
import { FIELD_IDS } from '../../../../constants/wizard';
import { MaskedCurrencyInput } from '../../../Inputs';
import { validateCurrency } from '../../../Inputs/MaskedCurrencyInput';

type CurrentResidenceMonthlyPaymentProps = {
  homeType?: string;
  errorMonthlyPayment?: { message?: string };
};

export function CurrentResidenceMonthlyPayment({ homeType, errorMonthlyPayment }: CurrentResidenceMonthlyPaymentProps) {
  return (
    <Controller
      name={FIELD_IDS.CURRENT_RESIDENCE_AMOUNT}
      rules={{ required: 'Monthly amount is required', validate: validateCurrency }}
      render={({ field }) => (
        <FormField
          label={<Label id="monthly-amount-label">Monthly {homeType === HomeType.OWN ? 'mortgage' : 'rent'}</Label>}
          control={<MaskedCurrencyInput {...field} aria-labelledby="monthly-amount-label" />}
          description={errorMonthlyPayment && <FormHelp>{String(errorMonthlyPayment.message)}</FormHelp>}
          error={!!errorMonthlyPayment}
        />
      )}
    />
  );
}
